import { render } from "./RegistrarAmbiente.vue?vue&type=template&id=5c238332&scoped=true"
import script from "./RegistrarAmbiente.vue?vue&type=script&lang=js"
export * from "./RegistrarAmbiente.vue?vue&type=script&lang=js"

import "./RegistrarAmbiente.vue?vue&type=style&index=0&id=5c238332&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\2. Fabrica 2022\\Proyecto_Andres_Fabrica\\proyecto_llaves\\version_principal\\frontend_proyecto_llaves\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c238332"]])

export default __exports__